import request from '@/utils/request'

export function submitProcess(data) {
  return request.post('/process/submit', data)
}

export function submitProcessFile(data) {
  return request.post('/process/submit-file', data)
}

export function getProcessTask(taskNo) {
  return request.get(`/process/${taskNo}`)
}

export function getProcessTaskDetail(taskNo, lite = false) {
  return request.get(`/process/task/${taskNo}/detail`, {
    params: lite ? { lite: true } : {}
  })
}

export function getProcessTaskProgress(taskNo) {
  return request.get(`/process/task/${taskNo}/progress`)
}

export function getProcessParagraphOutputs(taskNo, seqNos) {
  const list = Array.isArray(seqNos) ? seqNos : [seqNos]
  return request.get(`/process/task/${taskNo}/paragraphs/output`, {
    params: { seqNos: list.join(',') }
  })
}

export function resumeProcessTask(taskNo) {
  return request.post(`/process/task/${taskNo}/resume`)
}

export function regenerateProcessOutput(taskNo) {
  return request.post(`/process/task/${taskNo}/regenerate-output`, null, {
    timeout: 300000
  })
}

export function regenerateProcessParagraph(taskNo, seqNo) {
  return request.post(`/process/task/${taskNo}/paragraph/${seqNo}/regenerate`, null, {
    timeout: 120000
  })
}

export function useSourceProcessParagraph(taskNo, seqNo) {
  return request.post(`/process/task/${taskNo}/paragraph/${seqNo}/use-source`, null, {
    timeout: 120000
  })
}

export function getProcessTasks(params) {
  return request.get('/process/tasks', { params })
}

export function deleteProcessRecord(taskNo) {
  return request.delete(`/process/tasks/${taskNo}`)
}

export function uploadProcessDocx(file, params) {
  const formData = new FormData()
  formData.append('file', file)
  if (params.serviceType) {
    formData.append('serviceType', params.serviceType)
  }
  if (params.platform) {
    formData.append('platform', params.platform)
  }
  if (params.language) {
    formData.append('language', params.language)
  }
  return request.post('/process/upload/docx', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000
  })
}

export function uploadProcessReport(uploadId, file, reportRole = 'auto') {
  const formData = new FormData()
  formData.append('file', file)
  return request.post(`/process/upload/${uploadId}/report`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000,
    params: { reportRole }
  })
}

export function deleteProcessUpload(uploadId) {
  return request.delete(`/process/upload/${uploadId}`)
}

export function deleteProcessReport(uploadId, reportRole = 'auto') {
  return request.delete(`/process/upload/${uploadId}/report`, {
    params: { reportRole }
  })
}
